import { commonEnvsDev } from './generalEnvDev';

export const environment = {
  ...commonEnvsDev,
  IS_FRONT_ALLY: 3,
};
